import { PropsWithChildren, useEffect } from 'react'
import { useRouter } from 'next/router'

import { LenisProvider } from '@/contexts/lenis'
import { useLocaleStore } from '@/store/locale'
import { useRouterStore } from '@/store/router'

import { WPPageData } from '@/types'

type MetaProps = {
  pageProps?: WPPageData
}

export type LayoutProps = PropsWithChildren & MetaProps

const Layout = ({ children, pageProps }: LayoutProps) => {
  const router = useRouter()
  const setCurrentRoute = useRouterStore((state) => state.setCurrentRoute)
  const setCurrentLocale = useLocaleStore((state) => state.setCurrentLocale)
  const setCurrentTranslations = useLocaleStore(
    (store) => store.setCurrentTranslations
  )

  useEffect(() => {
    setCurrentRoute(router.asPath)
    setCurrentLocale(router.locale)
  }, [router.asPath, setCurrentRoute])

  useEffect(() => {
    setCurrentTranslations(pageProps?.wpml_translations || [])
  }, [pageProps])

  return (
    <LenisProvider
      direction={pageProps?.acf?.layout?.scroll_direction || 'horizontal'}
      // @ts-ignore
      pageProps={pageProps}
    >
      <div className="lg:flex lg:h-full lg:flex-nowrap">{children}</div>
    </LenisProvider>
  )
}

export default Layout
